import React, { useEffect, useState } from 'react';
import Container from '../../../../constants/Container';
import { formatMoney_2 } from '../../../../helpers/DateFormat';

interface TrialRptProps {
    onTrialReport: any
}
const TrialRptListView: React.FC<TrialRptProps> = ({ onTrialReport }) => {
    const [totalAmt, setOnTotalAmt] = useState({ totalDRAmt: 0, totalCRYear: 0 })

    useEffect(() => {
        if (onTrialReport?.results) {
            const totalDrAmount = onTrialReport.results.reduce((total: any, voucher: any) => {
                return total + (voucher.curyear_dr || 0);
            }, 0);

            const totalCRAmount = onTrialReport.results.reduce((total: any, voucher: any) => {
                return total + (voucher.curyear_cr || 0);
            }, 0);

            setOnTotalAmt({ totalDRAmt: totalDrAmount, totalCRYear: totalCRAmount });
        }
    }, [onTrialReport]);

    return (
        <Container padding>
            <div className="relative overflow-x-auto overflow-y-scroll !h-[78vh]">
                <table className="text-sm text-left rtl:text-right text-gray-100 whitespace-nowrap scroll-x-auto dark:text-gray-400 rounded w-full">
                    <thead className="text-[12px] text-gray-700 bg-slate-100 capitalize border-b dark:bg-sky-900 dark:text-slate-400 font-public-sans">
                        <tr>
                            <th scope="col" align='center' className="px-2 py-0.5 border border-slate200 dark:border-sky-800 w-10">
                                S.N.
                            </th>
                            <th scope="col" align='center' className="px-2 py-0.5 border border-slate200 dark:border-sky-800 w-10">
                                GLID
                            </th>
                            <th scope="col" align='center' className="px-2 py-0.5 border border-slate200 dark:border-sky-800">
                                General Ledger Name
                            </th>
                            <th scope="col" align='center' className="px-2 py-0.5 border border-slate200 dark:border-sky-800">
                                Debit Amount
                            </th>
                            <th scope="col" align='center' className="px-2 py-0.5 border border-slate200 dark:border-sky-800">
                                Credit Amount
                            </th>
                        </tr>
                    </thead>
                    <tbody className='text-slate-800'>
                        {Array.isArray(onTrialReport?.results) &&
                            onTrialReport?.results?.map((voucher: any, index: number) =>
                            (
                                <tr key={index} className="odd:bg-white hover:bg-slate-100 text-[12px] text-gray-800 dark:text-slate-300 odd:dark:bg-sky-900 even:bg-slate-50 even:dark:bg-sky-800 border-b font-public-sans dark:border-gray-700">
                                    <td align='center' className="px-2 border font-medium py-0.5 dark:border-sky-800 capitalize">
                                        {index + 1}.
                                    </td>
                                    <td align='center' className="px-2 border font-medium py-0.5 dark:border-sky-800 capitalize">
                                        {`${voucher?.glid ? voucher?.glid : ""}`}
                                    </td>
                                    <td align='left' className="px-2 font-medium py-0.5 border dark:border-sky-800 capitalize">
                                        <span className='font-bold'>{voucher?.glname}</span>{voucher?.subamt ? <div className='flex justify-between'><span className='pl-9 font-normal'>{voucher?.subledgname}</span><span className='pl-9 font-normal'>{voucher?.subamt ? formatMoney_2(voucher?.subamt) : formatMoney_2(0)}</span></div> : ""}
                                    </td>
                                    <td align='right' className="px-2 border py-0.5 dark:border-sky-800">
                                        {voucher?.curyear_dr ? formatMoney_2(voucher?.curyear_dr) : formatMoney_2(0)}
                                    </td>
                                    <td align='right' className="px-2 border py-0.5 dark:border-sky-800">
                                        {voucher?.curyear_cr ? formatMoney_2(voucher?.curyear_cr) : formatMoney_2(0)}
                                    </td>
                                </tr>
                            )
                            )
                        }
                        <tr className='text-[11px] text-black dark:text-slate-200 bg-gray100'>
                            <td align='right' colSpan={2} className={`px-1 py-0.5 font-bold border border-gray-300 dark:border-sky-800 font-public-sans`}>
                                Total Amount
                            </td>
                            <td align='right' colSpan={1} className={`px-1 py-0.5 font-bold border border-gray-300 dark:border-sky-800 font-public-sans`}>
                                {formatMoney_2(totalAmt?.totalDRAmt || 0)}
                            </td>
                            <td align='right' colSpan={1} className={`px-1 py-0.5 font-bold border border-gray-300 dark:border-sky-800 font-public-sans`}>
                                {formatMoney_2(totalAmt?.totalCRYear || 0)}
                            </td>
                            <td align='right' colSpan={1} className={`px-1 py-0.5 font-bold border border-gray-300 dark:border-sky-800 font-public-sans`}>
                                {formatMoney_2(totalAmt?.totalCRYear || 0)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Container>
    )
}
export default TrialRptListView